package br.com.texeratx.boardgametimeapp.ui.screens.signup

import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.domain.usecases.login.SignupUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansScreen
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import cafe.adriel.voyager.navigator.Navigator
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class SignupViewModel(
    private val signupUseCase: SignupUseCase,
    private val lang: LanguageManager
) : ScreenModel {

    var state = MutableStateFlow(SignupUiState())
        private set

    fun updateDisplayName(v: String) {
        state.value = state.value.copy(displayName = v)
    }

    fun updateEmail(v: String) {
        state.value = state.value.copy(email = v)
    }

    fun updatePassword(v: String) {
        state.value = state.value.copy(password = v)
    }

    fun updateConfirmPassword(v: String) {
        state.value = state.value.copy(confirmPassword = v)
    }

    fun signup(navigator: Navigator) {
        screenModelScope.launch {
            val s = state.value

            if (s.displayName.isBlank()) {
                state.value = s.copy(error = lang.strings.value.unknownError)
                return@launch
            }
            if (s.email.isBlank()) {
                state.value = s.copy(error = lang.strings.value.unknownError)
                return@launch
            }
            if (s.password.isBlank()) {
                state.value = s.copy(error = lang.strings.value.passwordRequired)
                return@launch
            }
            if (s.password != s.confirmPassword) {
                state.value = s.copy(error = lang.strings.value.passwordsDoNotMatch)
                return@launch
            }

            state.value = s.copy(isLoading = true, error = null)

            val result = signupUseCase(
                email = s.email,
                password = s.password,
                displayName = s.displayName
            )

            result.fold(
                onSuccess = {
                    Napier.d("SignupViewModel → signup OK")
                    state.value = state.value.copy(isLoading = false)
                    navigator.replaceAll(MyClansScreen())
                },
                onFailure = { e ->
                    Napier.e("SignupViewModel → erro no signup", e)
                    state.value = state.value.copy(
                        isLoading = false,
                        error = e.message ?: lang.strings.value.unknownError
                    )
                }
            )
        }
    }
}
